export function gradientCardAccardion() {
    let $parent = $(".gradient-cards-holder.opened-on-mobile .gradient-card");
    $parent.each(function () {
        let $this = $(this);
        if (!$this.find(".info-card-holder").length) {
            $this.addClass("without-info");
        }
    });
    $parent.on("click", "h5,.h5", function () {
        let $this = $(this);
        let cardParent = $this.parents(".content-holder");
        if (window.innerWidth < 768 && !$this.parent(".gradient-card").hasClass("without-info")) {
            if (!$this.parents(".gradient-card").hasClass("show")) {
                cardParent.addClass("show");
                $parent.removeClass("show").find(".info-card-holder").slideUp(300);
                $this.parent(".gradient-card").addClass("show").find(".info-card-holder").slideDown(300);
            } else {
                cardParent.removeClass("show");
                $parent.removeClass("show").find(".info-card-holder").slideUp(300);
            }
        }
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/gradientCardAccardion.js